import { Link } from "react-router-dom";
import classes from "./ModalContentList.module.css";

const ModalContentList = ({
  modalContents,
  closeChildMenuHandler,
  modalTitle,
}) => {
  if (!modalContents) {
    return null;
  }

  return modalContents.map((content, index) => (
    <div
      key={content.id}
      className={
        index < modalContents.length - 1
          ? `col-lg-4 col-md-4 ${classes["dropdown-col"]}`
          : `col-lg-4 col-md-4 ${classes["without-border"]}`
      }
    >
      <div
        className={
          modalTitle === "nav_modal_title_software"
            ? classes["text-wrapper--software"]
            : classes["text-wrapper--hardware"]
        }
      >
        <h5
          className={
            modalTitle === "nav_modal_title_software"
              ? `${content.color} ${classes["heading--software"]}`
              : `${content.color} ${classes["heading--hardware"]}`
          }
        >
          {content.title}
        </h5>
        {content.imgUrl ? (
          <Link to={content.link} onClick={() => closeChildMenuHandler()}>
            <img
              src={content.imgUrl}
              alt="solution"
              className={classes.image}
            />
          </Link>
        ) : null}
        <div>
          <p>{content.contents}</p>
          {content.contents2 ? <p>{content.contents2}</p> : null}
        </div>
      </div>
      <div className={`${content.color}-button custom-btn ${classes.button}`}>
        <Link to={content.link} onClick={() => closeChildMenuHandler()}>
          {content.buttonText}
        </Link>
      </div>
    </div>
  ));
};

export default ModalContentList;
